const popupsClose = document.querySelectorAll('.popup .popup-close')
const popupsTriggers = document.querySelectorAll('.open-popup-btn')

popupsClose?.forEach(item => item.addEventListener('click', closePopup))
popupsTriggers?.forEach(item => item.addEventListener('click', openPopup))

function closePopup(e) {
    let popup = this.closest('.popup')
    popup?.classList.add('dnone')
    document.body.classList.remove('noscroll')

}
function openPopup(e) {
    let popupId = this.getAttribute('popup')
    let popup = document.getElementById(popupId)
    popup?.classList.remove('dnone')
    if(popup) {
        document.body.classList.add('noscroll')
    }
}